'use strict';

var _ = require('lodash'),
    $ = require('jquery'),
    $body = $('body'),
    $html = $('html'),
    $videoForward = $('#forwardVideo'),
    $videoReverse = $('#reverseVideo'),
    $initialBackgroundVideo = $('.background-repeat'),
    $backgroundIntroVideo = $('.background-image-process'),
    $footerImage = $('.background-image'),
    $scrollDownPromptBox = $('.scroll-down-prompt-box'),
    $scrollDownPrompt = $('.scroll-down-prompt'),
    $newletterSignUp = $('#newsletterSignup'),
    $navDown = $('.fa-angle-down'),
    $startAConversation = $('#startAConversation'),
    $pageTopHero = $('#pageTopHero'),
	$processPage = $('#processPage'),
    $angleDown = $('.fa-angle-down'),
    MikesMagicVideoParty = require('mikes-magic-video-party'),
    firstTime = true,
    videoStatusPlaying = false,
    videoParty,
    is_iPad = navigator.userAgent.match(/iPad/i) != null,
    portrait;

$(window).unload( function() {
    $(window).scrollTop(0);
});

//disable horizontal scroll
$body.css('overflow-x', 'hidden');
$body.css('max-width','100%');
$initialBackgroundVideo[0].play();

//add a check for landscape or vertical
//change text to tell user to click to move forward
//delete top hero

_setupProcessPageScrollListener();

initialize();

function initialize() {
	var windowWidth = $(window).width();

    if(is_iPad){
        $html.css('overflow-x', 'hidden');
        tabletChecks();
    }

    if(windowWidth < 768){
        return;
    }

    $footerImage.css('opacity','0');

	if(windowWidth < 900){
		console.log('resize');
		$videoForward.css('width', windowWidth);
		$videoReverse.css('width', windowWidth);
		$('.point-description').each(function(element){
			element = $(this);
			element.css('width', windowWidth/2);
		});
	}

	if(windowWidth < 450){
		$('.point-description').empty();
		$('.points-container').css('position','static');
	}

	if(windowWidth < 350){
		$('.points-container').empty();
	}
	
    videoParty = new MikesMagicVideoParty($videoForward[0], $videoReverse[0], window.videoConfig);

    videoParty.skipToIndex(0);
    setActivePointByCurrentTimeToNearestIndex();

    _setupPointsClickListeners();
    _setupFadeIntroVideoOnScroll();

    $videoForward.addClass('init-load');
    $videoReverse.addClass('init-load');
    $startAConversation.css('visibility', 'hidden');
}

function _setupProcessPageScrollListener() {
    document.querySelector('#processPage').addEventListener('wheel', _.debounce(_handlePageScroll, 100, { maxWait: 500 }));
}

function _handlePageScroll(event) {
    if(event.deltaY === 0) {
        return;
    }

    if(event.deltaY > 0  && !videoStatusPlaying) {
        console.log('Play Forward');
        videoStatusPlaying = true;

        $('.points-container .point')
            .removeClass('active')
            .eq(videoParty.getCurrentIndex())
            .addClass('active');

        checkIfAboutToLoadResultsOnScroll();

        $videoReverse.removeClass('showing').addClass('hiding');
        $videoForward.removeClass('hiding').addClass('showing');

        $('.point-description')
            .removeClass('active');

        videoParty.goToNext()
            .then(function(){
                setActivePointByCurrentTimeToNearestIndex();
                if(videoParty.getCurrentIndex() === 7){
                    $videoForward.addClass('dim');
                    $videoReverse.addClass('dim');
                }
            });

    } else if (!videoStatusPlaying && videoParty.getCurrentIndex() !== 0 && videoParty.getCurrentIndex() !== 1){
        console.log('Play Backward');
        videoStatusPlaying = true;

        $('.points-container .point')
            .removeClass('active')
            .eq(videoParty.getCurrentIndex() - 2)
            .addClass('active');

        //$scrollDownPromptBox.css('opacity','1');
        $navDown.css('opacity','1');
        $scrollDownPrompt.css('opacity','1');

        $videoReverse.removeClass('hiding').addClass('showing');
        $videoForward.removeClass('showing').addClass('hiding');

        $('.point-description')
            .removeClass('active');

        if(videoParty.getCurrentIndex() === 7){
            $videoForward.toggleClass('dim');
            setTimeout(function(){
                $videoReverse.toggleClass('dim')
            },300);
        }

        videoParty.goToPrevious()
            .then(setActivePointByCurrentTimeToNearestIndex);
    }
}

function _setupPointsClickListeners() {
    $('.point').on('click touchstart', _handlePointClick);
}

function _handlePointClick() {
    if(!videoStatusPlaying){
        videoStatusPlaying = true;

        if(is_iPad){
            $scrollDownPrompt.html('Click Bullet Points To Navigate');
        }

        if(videoParty.getCurrentIndex() === 7){
            $videoForward.toggleClass('dim');
            setTimeout(function(){
                $videoReverse.toggleClass('dim')
            },300);
        }

        var index = parseInt($(this).attr('index'));

        $('.points-container .point')
            .removeClass('active');

        $(this).addClass('active');

        if(Math.abs(index - videoParty.getCurrentIndex()) === 1){
            if(videoParty.getCurrentIndex() > index){
                $videoReverse.removeClass('hiding').addClass('showing');
                $videoForward.removeClass('showing').addClass('hiding');
            } else {
                $videoReverse.removeClass('showing').addClass('hiding');
                $videoForward.removeClass('hiding').addClass('showing');
            }

            $('.point-description')
                .removeClass('active');

            videoParty.goToIndex(index)
                .then(function(){
                    setActivePointByCurrentTimeToNearestIndex();
                    if(videoParty.getCurrentIndex() === 7){
                        $videoForward.addClass('dim');
                        $videoReverse.addClass('dim');
                        //$scrollDownPromptBox.css('opacity','0');
                        $navDown.css('opacity','0');
                        $scrollDownPrompt.css('opacity','0');
                    } else {
                        //$scrollDownPromptBox.css('opacity','1');
                        $navDown.css('opacity','1');
                        $scrollDownPrompt.css('opacity','1');
                    }
                });
        } else {
            videoParty.skipToIndex(index);
            setActivePointByCurrentTimeToNearestIndex();
            if(videoParty.getCurrentIndex() === 7){
                $videoForward.addClass('dim');
                $videoReverse.addClass('dim');
                //$scrollDownPromptBox.css('opacity','0');
                $navDown.css('opacity','0');
                $scrollDownPrompt.css('opacity','0');
            } else {
                //$scrollDownPromptBox.css('opacity','1');
                $navDown.css('opacity','1');
                $scrollDownPrompt.css('opacity','1');
            }
        }
    }
}

function setActivePointByCurrentTimeToNearestIndex() {
    var currentTime = videoParty.getCurrentTime(),
        closestPoint = window.videoConfig.points
            .filter(function(item) {
                return item.slidingTemplate;
            })
            .reduce(function(previous, current) {
                return (Math.abs(current.timeIndex - currentTime) < Math.abs(previous.timeIndex - currentTime) ? current : previous);
            }),
        indexOfClosestPoint = _.findIndex(window.videoConfig.points.filter(function(item) { return item.slidingTemplate; }), function(point) {
            return point === closestPoint;
        });

    $('.points-container .point')
        .removeClass('active')
        .eq(indexOfClosestPoint)
        .addClass('active');

    if(!firstTime){
        $('.point-description')
            .removeClass('active')
            .eq(indexOfClosestPoint)
            .addClass('active');
    }

    firstTime = false;
    setTimeout(function(){
        videoStatusPlaying = false;
    }, 1000);
}

function _setupFadeIntroVideoOnScroll(){
    $(window).scroll(function(){
        var position = 100 * Math.ceil(window.scrollY / 100);

        if(position <= 100){
            postTabletCheck();
            $backgroundIntroVideo.css('opacity','1');
        } else {
            $backgroundIntroVideo.css('opacity','0');
        }

        if(500 <= position ){
            $('body').addClass('process-page-scroll-lock');
            $("html, body").animate({ scrollTop: 1200 }, "slow");
            postTabletCheck();
            $newletterSignUp.css('opacity','0');
			$scrollDownPromptBox.css('position','inherit');
        }

        if(1100 <= position){
            $footerImage.css('opacity','1');
            postTabletCheck();
        } else {
            $footerImage.css('opacity','0');
        }
    })
}

function checkIfAboutToLoadResultsOnScroll(){
    var index = videoParty.getCurrentIndex();
    if(index == 6 || index == 7){
        $navDown.css('opacity','0');
        $scrollDownPrompt.css('opacity','0');
    } else {
        $navDown.css('opacity','1');
        $scrollDownPrompt.css('opacity','1');
    }
}

function tabletChecks(){
    if(window.innerHeight > window.innerWidth){
        portrait = 'portrait';
        console.log('portrait');
    }else{
        portrait = 'landscape';
        console.log('landscape');
    }
}

function postTabletCheck(){
    console.log('check to remove', portrait);
    if(portrait == 'landscape'){
        $pageTopHero.remove();
        $processPage.css('margin-top', '10vh');
        $angleDown.css('display','none');
        $scrollDownPrompt.html('Tap The First Bullet Point To Begin');
        console.log(1);
    } else if (portrait == 'portrait'){
        $angleDown.css('display','none');
        $scrollDownPrompt.html('Tap The First Bullet Point To Begin');
        console.log(2);
    }
}